import { render, staticRenderFns } from "./AdminUserDelete.vue?vue&type=template&id=5778af82&scoped=true"
import script from "./AdminUserDelete.vue?vue&type=script&lang=js"
export * from "./AdminUserDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminUserDelete.vue?vue&type=style&index=0&id=5778af82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5778af82",
  null
  
)

export default component.exports